// extracted by mini-css-extract-plugin
export default {"ListItemMetadata_0":"IssueItemMetadata-module__ListItemMetadata_0--iaEA1"};